export {
  messageTemplatesApi,
  useAttachFilesMutation,
  useDeleteMutation,
  useGetFilesMutation,
  useGetQuery,
  useGetSearchResultQuery,
  useLazyGetQuery,
  useLazyGetSearchResultQuery,
  useLazySearchForSystemQuery,
  useRemoveFilesMutation,
  useSearchForSystemQuery,
  useSearchMutation,
  useUpdateMutation,
} from './api';

export {
  MessageTemplatesEndpoints,
  type AttachFilesToMessageTemplateRequest,
  type AttachFilesToMessageTemplateResponse,
  type DeleteMessageTemplateRequest,
  type DeleteMessageTemplateResponse,
  type GetFilesMessageTemplateRequest,
  type GetFilesMessageTemplateResponse,
  type GetMessageTemplateRequest,
  type GetMessageTemplateResponse,
  type GetMessageTemplatesSearchResultRequest,
  type GetMessageTemplatesSearchResultResponse,
  type ModelAttachFilesToMessageTemplate,
  type ModelGetFilesMessageTemplate,
  type ModelGetFilesMessageTemplateData,
  type ModelMessageTemplate,
  type ModelMessageTemplateFile,
  type ModelMessageTemplateLite,
  type ModelMessageTemplateSearchFilter,
  type ModelMessageTemplateSearchResult,
  type ModelMessageTemplateWithFiles,
  type ModelRemoveFilesToMessageTemplate,
  type ModelUpdateMessageTemplate,
  type RemoveFilesFromMessageTemplateRequest,
  type RemoveFilesFromMessageTemplateResponse,
  type SearchForSystemMessageTemplatesRequest,
  type SearchForSystemMessageTemplatesResponse,
  type SearchMessageTemplatesRequest,
  type SearchMessageTemplatesResponse,
  type UpdateMessageTemplateRequest,
  type UpdateMessageTemplateResponse,
} from './types';
